"use strict";

require("core-js/shim");

require("regenerator/runtime");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel/polyfill is allowed");
}
global._babelPolyfill = true;


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/babel-core/lib/polyfill.js
 ** module id = 417
 ** module chunks = 0
 **/